// Copyright © 2021 Move Closer
/**
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 * @author Olga Milczek <olga.milczek@movecloser.pl>
 */
export var GalleryVersion;
(function (GalleryVersion) {
    GalleryVersion["Carousel"] = "carousel";
    GalleryVersion["Stack"] = "stack";
    // DEPRECATED
    GalleryVersion["Tiles"] = "tiles";
})(GalleryVersion || (GalleryVersion = {}));
export var GallerySelectionOptions;
(function (GallerySelectionOptions) {
    GallerySelectionOptions["Default"] = "default";
    GallerySelectionOptions["Smart"] = "smart";
})(GallerySelectionOptions || (GallerySelectionOptions = {}));
